export interface IUserProfileModel {
  // userId: string;
  // firstName: string;
  // lastName: string;
  // email: string;
  // profilePhotoUrl: string;
  // preferredLanguage: string;
  // preferredUnitSystem: string;
  // authority: string;

  email: string;
  firstName: string;
  lastName: string;
  preferredLanguage: string;
  preferredUnitSystem: string;
  profilePhotoUrl: string;
  userId: string;
}

export interface ProfileOrganizationModel {
  userId: string;
  organizationId: string;
  organizationName: string;
  organizationShortName: string;
  organizationAdmins: orgAdminData[];
  userType: UserType;
  playerId: string;
  activeLicenses: OrgLicense[];
}

export interface orgAdminData {
  email: string;
  name: string;
}

export interface OrgLicense {
  license: License;
  features: Feature[];
  startDate: Date;
  expirationDate: Date;
}

export enum License {
  Unknown = 'Unknown',
  Standard = 'Standard',
  DataAPI = 'DataAPI',
}

export enum Feature {
  Unknown = 'Unknown',
  FreeKickTracking = 'FreeKickTracking',
  PenaltyKickTracking = 'PenaltyKickTracking',
  CornerKickTracking = 'CornerKickTracking',
  GoalKeeperDistributionTracking = 'GoalKeeperDistributionTracking',
  ShootingPracticeTracking = 'ShootingPracticeTracking',
  DataApiSelfService = 'DataApiSelfService'
}

export enum UserType {
  Admin = 'admin',
  Analyst = 'analyst',
  Coach = 'coach',
  Scout = 'scout',
  Player = 'player',
  StadiumTagger = 'stadiumTagger',
  CloudLiveDashboard = 'cloudLiveDashboard',
  User = 'user',
  Other = 'other',

  // small case letter
  admin = 'admin',
  analyst = 'analyst',
  coach = 'coach',
  scout = 'scout',
  player = 'player',
  stadiumTagger = 'stadiumTagger',
  cloudLiveDashboard = 'cloudLiveDashboard',
  other = 'other',
}
